export const dateReplaceHyphen = (dateString: string, hyphen = "."): string => {
  return dateString
    .split("-")
    .join(hyphen)
    .split(`${hyphen}0`)
    .join(hyphen);
};
